var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8636_18763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 45C35.4263 45 45.4999 34.9264 45.4999 22.5C45.4999 10.0736 35.4263 0 22.9999 0C10.5735 0 0.499878 10.0736 0.499878 22.5C0.499878 34.9264 10.5735 45 22.9999 45Z",
    fill: "url(#paint0_linear_8636_18763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.623 14.4658C28.8165 14.4658 28.1613 15.1211 28.1613 15.9275C28.1613 16.734 28.8165 17.3892 29.623 17.3892C30.4294 17.3892 31.0847 16.734 31.0847 15.9275C31.0847 15.1211 30.4294 14.4658 29.623 14.4658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1006 16.3413C19.7034 16.3413 16.9413 19.1034 16.9413 22.5006C16.9413 25.8978 19.7034 28.6599 23.1006 28.6599C26.4978 28.6599 29.2599 25.8978 29.2599 22.5006C29.2599 19.1034 26.4978 16.3413 23.1006 16.3413ZM23.1006 26.4421C20.9232 26.4421 19.1591 24.6679 19.1591 22.5006C19.1591 20.3332 20.9333 18.5591 23.1006 18.5591C25.2679 18.5591 27.0421 20.3332 27.0421 22.5006C27.0421 24.6679 25.2679 26.4421 23.1006 26.4421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9902 35.0005H18.0104C13.8672 35.0005 10.5003 31.6336 10.5003 27.4904V17.5106C10.5003 13.3674 13.8672 10.0005 18.0104 10.0005H27.9902C32.1333 10.0005 35.5003 13.3674 35.5003 17.5106V27.4904C35.5003 31.6336 32.1333 35.0005 27.9902 35.0005ZM18.0104 12.3493C15.1676 12.3493 12.8491 14.6678 12.8491 17.5106V27.4904C12.8491 30.3331 15.1676 32.6517 18.0104 32.6517H27.9902C30.8329 32.6517 33.1515 30.3331 33.1515 27.4904V17.5106C33.1515 14.6678 30.8329 12.3493 27.9902 12.3493H18.0104Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8636_18763",
    x1: 7.09031,
    y1: 6.59043,
    x2: 38.9094,
    y2: 38.4096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFBB36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FF5176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F63395"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A436D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4EED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8636_18763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.499878)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon_instagram.2597db2c23e05b8e31da5591c3c29c6d.svg";
export { ForwardRef as ReactComponent };